import { CheckoutButton } from "components/UI/atoms/checkout-button";
import {
  MenuCartBody,
  MenuCartIcon,
  MenuCartItem,
  TimerHeader
} from "components/UI/molecules";
import { StatusArea } from "components/UI/molecules/status-area";
import { useAppContext } from "context/app-context";
import { useCartContext } from "context/cart-context";
import { useCartCountdown } from "context/cart-context/utils/useCartCountdown";
import { useEffect } from "react";
import "./index.scss";

export const MenuCart = () => {
  const { sessionInfo } = useAppContext();

  const {
    cart: { cards, isCartLoading, affiliateUrl },
    setAffiliateUrl,
    cart,
    emptyCart
  } = useCartContext();
  const handleCountdownTimeout = () =>
    emptyCart({ userID: sessionInfo.userID });
  const countDown = useCartCountdown(cart, handleCountdownTimeout);
  const hasCards = !!cards?.length;

  useEffect(() => {
    hasCards && setAffiliateUrl();
  }, [cards, hasCards, setAffiliateUrl]);

  return (
    <div className="menu-cart-area">
      <MenuCartIcon length={cards.length} seconds={countDown} {...cart} />
      <MenuCartBody>
        {!hasCards && <p className="single-text">Your cart is empty.</p>}
        {hasCards && (
          <>
            <TimerHeader numberOfCards={cards.length} seconds={countDown} />
            <ul className="list">
              {cards.map(
                ({
                  cardType,
                  imageSrc,
                  name,
                  uuid,
                  value,
                  price,
                  brandUuid,
                  listingUuid,
                  userUuid
                }) => (
                  <MenuCartItem
                    key={uuid}
                    card={{
                      cardType,
                      imageSrc,
                      name,
                      uuid,
                      value,
                      price,
                      imageAlt: "", // TODO add this custom prop
                      cardUrl: "", // TODO add this custom prop
                      brandUuid,
                      listingUuid,
                      userUuid
                    }}
                  />
                )
              )}
            </ul>
            <StatusArea isCartLoading={isCartLoading} />
            <CheckoutButton
              isCartLoading={isCartLoading}
              affiliateUrl={affiliateUrl}
            />
            <div className="guarantee">90 Day Money-Back Guarantee</div>
          </>
        )}
      </MenuCartBody>
    </div>
  );
};
